var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9735 21.6153H21.7918V35.9089C21.7918 37.3591 22.9676 38.5335 24.4164 38.5335H31.5803C33.0289 38.5335 34.2048 37.3592 34.2048 35.9089V21.6153H39.0215C39.8195 21.6153 40.5368 21.1348 40.8437 20.3974C41.1473 19.663 40.9784 18.814 40.4146 18.2502L29.391 7.22532C28.6211 6.45696 27.3739 6.45696 26.6023 7.22532L15.5806 18.2502C15.0167 18.814 14.8478 19.6615 15.1531 20.3974C15.4597 21.1333 16.1755 21.6153 16.9735 21.6153Z",
    fill: "#E9A5F3",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4369 26.9724C48.1307 26.9724 47.0711 28.0322 47.0711 29.3397V39.2382C47.0711 42.2035 44.6573 44.6157 41.6919 44.6157H14.3051C11.3397 44.6157 8.92747 42.2035 8.92747 39.2382V29.3397C8.92747 28.0322 7.86624 26.9724 6.56017 26.9724C5.25255 26.9724 4.19287 28.0322 4.19287 29.3398V39.2383C4.19287 44.8141 8.72912 49.3505 14.3051 49.3505H41.6919C47.2678 49.3505 51.8043 44.8142 51.8043 39.2383V29.3398C51.8043 28.0322 50.7445 26.9724 49.4369 26.9724Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfile);
export default __webpack_public_path__ + "static/media/uploadfile.da836d72d1530cee1a8e71eb243be7ae.svg";
export { ForwardRef as ReactComponent };